"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.variableNameToTemperatureUnit = void 0;
const TemperatureUnit_1 = require("./TemperatureUnit");
function variableNameToTemperatureUnit(variableName) {
    switch (variableName) {
        case 'temperatureC':
            return TemperatureUnit_1.TemperatureUnit.Celsius;
        case 'temperatureF':
            return TemperatureUnit_1.TemperatureUnit.Fahrenheit;
        case 'temperatureK':
            return TemperatureUnit_1.TemperatureUnit.kelvin;
    }
    return TemperatureUnit_1.TemperatureUnit.kelvin;
}
exports.variableNameToTemperatureUnit = variableNameToTemperatureUnit;
//# sourceMappingURL=variableNameToTemperatureUnit.js.map